import { Divider, ListItem, ListItemText } from '@mui/material'
import { Fragment, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { setInvoiceEmailSubject } from 'store/invoices/invoices.slice'
import { InvoiceResponse } from 'store/invoices/invoices.types'
import { cleanString } from 'utils/common'

const InvoiceEmailSubject = ({
  userInvoiceId,
  loadNumber,
}: InvoiceResponse) => {
  const dispatch = useDispatch()
  const user = useSelector((state: RootState) => state.auth.user)

  const senderName = useMemo(() => {
    const companyName = user?.companyName?.trim()
    if (companyName) {
      return companyName
    }
    return user?.email?.trim() ?? ''
  }, [user?.companyName, user?.email])

  const subject = useMemo(() => {
    return `Invoice ${userInvoiceId} from ${senderName}. Your load# ${loadNumber}`
  }, [loadNumber, senderName, userInvoiceId])

  useEffect(() => {
    if (!!subject) {
      dispatch(setInvoiceEmailSubject(cleanString(subject)))
    }
  }, [subject, dispatch])

  return (
    <Fragment>
      <ListItem>
        <ListItemText>Subject: {subject}</ListItemText>
      </ListItem>
      <Divider />
    </Fragment>
  )
}

export default InvoiceEmailSubject
